<template>
    <v-container class="my-5">
        <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
        <v-dialog v-model="dialogCellNumberWrong" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogCellNumberWrong = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo  Modal para Cambiar Permisos (Usuario -> Vigilante)    -->
        <v-dialog
                v-model="dialogMoveUp"
                max-width="500"
        >
            <v-form @submit.prevent="moveUpUserToGuard()">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('move_up_user_to_guard')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogMoveUp = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-autocomplete
                                    v-model="emailGuest"
                                    :items="items"
                                    prepend-icon="mdi-email"
                                    :loading="isLoading"
                                    :search-input.sync="search2"
                                    :item-text="example"
                                    item-value="id"
                                    :placeholder="$t('placeholder_invitados2')"
                                    :label="$t('usuarios')"
                                    :error-messages="errores.idUser"
                                    :no-data-text="$t('no_resultados')"
                                    clearable
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            @click="data.select"
                                    >
                                        <v-avatar left>
                                            <v-img :src="data.item.avatar"></v-img>
                                        </v-avatar>
                                        {{ data.item.first_name }} {{data.item.last_name}}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-avatar>
                                            <img :src="data.item.avatar">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.first_name }} {{data.item.last_name}}</v-list-item-title>
                                            <v-list-item-sub-title v-html="data.item.group"></v-list-item-sub-title>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialogMoveUp = false"
                        >
                            {{$t('cerrar')}}
                        </v-btn>
                        <v-spacer/>
                        <v-btn
                                :loading="loading"
                                color="primary"
                                type="submit"
                        >
                            {{$t('modificar')}}
                            <v-icon dark right>mdi-swap-horizontal</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Guardias     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_tutor')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>

                    <v-btn
                            color="primary"
                            @click="deleteTutor()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
        <v-dialog v-model="dialogImageFront" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageFront"
                            :src="imageFrontURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingFront()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
        <v-dialog v-model="dialogImageBack" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageBack"
                            :src="imageBackURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingBack()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfileURL"
                            ref="clipperImageProfile"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfile()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{ $t('tutores') }}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="600px">
                <template v-slot:activator="{ on }">
                    <v-layout row wrap class="justify-center">
                        <v-btn
                                color="primary"
                                dark
                                v-on="on"
                                @click="update = false,
                                cleanFields()"> + {{ $t('anadir_tutor') }}
                        </v-btn>
<!--                        <v-btn-->
<!--                                arrow_upward-->
<!--                                color="primary"-->
<!--                                @click="dialogMoveUp = true, emailGuest = '', entries = [], errores = [] "-->
<!--                        >-->
<!--                            <v-icon dark left>mdi-swap-horizontal</v-icon>-->
<!--                            {{$t('cambiar_permisos')}}-->
<!--                        </v-btn>-->
                    </v-layout>
                </template>
                <v-form
                        @submit.prevent="update
                                        ? updateTutor(id_update)
                                        : createTutor()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('tutores') }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-text-field
                                    v-model="first_name"
                                    autofocus
                                    prepend-icon="mdi-account"
                                    name="first_name"
                                    :label="$t('Nombre')"
                                    :error-messages="errores.first_name"
                            >
                            </v-text-field>
                            <v-text-field
                                    v-model="last_name"
                                    prepend-icon="mdi-account-outline"
                                    name="last_name"
                                    :label="$t('Apellido')"
                                    :error-messages="errores.last_name"
                            >
                            </v-text-field>
                            <v-layout row wrap class="text-center">
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultFrontURL"
                                            v-if="resultFrontURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-alert
                                            v-if="errores.idFront"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.idFront}}
                                    </v-alert>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageFront = true, degrees = 0, ratio = '1'"
                                                accept="image/*"
                                                v-model="imageFrontURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_ine')}}<br>[{{$t('atras')}}]
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultBackURL"
                                            v-if="resultBackURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-alert
                                            v-if="errores.idBack"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.idBack}}
                                    </v-alert>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageBack = true, degrees = 0, ratio = '1'"
                                                accept="image/*"
                                                v-model="imageBackURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap class="text-center">
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_perfil')}}
                                    </v-label>
                                    <br>
                                    <v-avatar
                                            class="profile"
                                            color="grey"
                                            size="200"
                                    >
                                        <v-img :src="resultProfileURL"
                                               v-if="resultProfileURL"
                                        >
                                        </v-img>
                                    </v-avatar>
                                    <br>
                                    <v-alert
                                            v-if="errores.avatar"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.avatar}}
                                    </v-alert>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageProfile = true, degrees = 0, ratio = '1'"
                                                accept="image/*"
                                                v-model="imageProfileURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                            <vue-tel-input
                                    class="mt-3 mb-3"
                                    v-model="celular"
                                    @onInput="onInput"
                            >
                                <v-alert v-if="errores.cellNumber" type="error">{{errores.cellNumber}}</v-alert>
                            </vue-tel-input>
                            <v-alert outlined v-if="errores.cellNumber" type="error">{{errores.cellNumber}}</v-alert>
<!--                            <v-layout row wrap>-->
<!--                                <v-flex v-bind:class="(update) ? 'xs12 sm6 md6 lg6 xl6' : 'xs12 sm12 md12 lg12 xl12'">-->
                                    <v-text-field
                                            v-model="email"
                                            prepend-icon="mdi-email"
                                            name="email"
                                            label="E-Mail"
                                            :error-messages="errores.email"
                                            autocomplete="username"
                                    >
                                    </v-text-field>
<!--                                </v-flex>-->
<!--                                <v-flex v-show="update" v-bind:class="(update) ? 'xs12 sm6 md6 lg6 xl6' : 'xs12 sm12 md12 lg12 xl12'">-->
<!--                                    <v-checkbox-->
<!--                                            v-model="activa"-->
<!--                                            name="activa"-->
<!--                                            :label="$t('Activo')"-->
<!--                                            :error-messages="errores.activa"-->
<!--                                    ></v-checkbox>-->
<!--                                </v-flex>-->
<!--                            </v-layout>-->
                            <v-checkbox
                                    v-model="change_password"
                                    v-if="update" disable
                                    name="change_password"
                                    label="Cambiar Contraseña"
                            ></v-checkbox>
                            <ValidationObserver>
                                <ValidationProvider :rules="change_password ? 'required|password:@confirm' : ''" v-slot="{ errors }">
                                    <v-text-field
                                            v-model="password"
                                            :disabled="update && !change_password ? true: false"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show"
                                            autocomplete="new-password"
                                            :error-messages="change_password ? errores.password : ''">
                                    </v-text-field>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider name="confirm" :rules="change_password ? 'required' : ''" v-slot="{ errors }">
                                    <v-text-field
                                            v-model="confirmation"
                                            :disabled="update  && !change_password ? true: false"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password_confirm')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show"
                                            autocomplete="new-password">
                                    </v-text-field>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </ValidationObserver>
                            <v-alert
                                    :value=alerta
                                    type="warning"
                                    outlined
                                    transition="scale-transition"
                            >
                                Fallo con el Servidor
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="clear(),
                                    dialog = false"
                            >{{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    :loading="loading"
                                    v-if="update"
                                    color="primary"
                                    type="submit"
                            >{{$t('modificar')}}
                            </v-btn>
                            <v-btn
                                    :loading="loading"
                                    v-else
                                    color="primary"
                                    type="submit"
                            >{{$t('agregar')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    {{$t('tutores')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-account-search"
                            :label="$t('Buscar')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :loading="loadingTutors"
                        :items="tutors"
                        :search="search"
                        class="elevation-1"
                >
                    <template v-slot:items="props">
                        <td>{{ props.item.first_name }}</td>
                        <td>{{ props.item.last_name }}</td>
                        <td>{{ props.item.cellNumber }}</td>
                        <td>{{ props.item.email }}</td>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-icon
                                medium
                                color="grey"
                                class="mr-2"
                                @click="fillFields(item), update = true, dialog = true, id_update = item.id"
                        >
                            mdi-account-edit
                        </v-icon>
                        <v-icon
                                medium
                                color="red"
                                @click="deleteDialog = true, idGuardDelete = item.id"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                    <template v-slot:no-results>
                        <v-alert type="warning">
                            {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                        </v-alert>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import {mapState} from 'vuex'
import Vue from 'vue'
import {required} from 'vee-validate/dist/rules'

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

extend('required', {
  ...required,
  message: 'This field is required'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'guards',
  created () {
    this.getTutors()
  },
  data: () => ({
    show: false,
    alerta: false,
    dialog: false,
    update: false,
    id_update: 0,
    id_house: '',
    first_name: '',
    last_name: '',
    celular: '',
    email: '',
    email_aux: '',
    celular_aux: '',
    password: '',
    errores: [],
    headers: [],
    houses: [],
    tutors: [],
    activa: '',
    change_password: '',
    loadingTutors: false,
    confirmation: '',
    search: '',
    // Imágenes
    dialogImageFront: false,
    dialogImageBack: false,
    dialogImageProfile: false,
    imageFrontURL: '',
    imageBackURL: '',
    imageProfileURL: '',
    resultFrontURL: '',
    resultBackURL: '',
    resultProfileURL: '',
    resultAuxFrontURL: '',
    resultAuxBackURL: '',
    resultAuxProfileURL: '',
    // Delete Guard
    deleteDialog: false,
    idGuardDelete: 0,
    // Move Up
    dialogMoveUp: false,
    emailGuest: '',
    isLoading: false,
    search2: null,
    entries: [],
    band_cellphone: false,
    dialogCellNumberWrong: false,
    loading: false,
    degrees: 0,
    ratio: '1'
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'last_name'
      },
      {
        text: this.$t('celular'),
        align: 'left',
        sortable: true,
        value: 'cellNumber'
      },
      {
        text: 'E-Mail',
        align: 'left',
        sortable: true,
        value: 'email'
      }
    ]
  },
  computed: {
    ...mapState(['language']),
    fields () {
      if (!this.emailGuest) return []

      return Object.keys(this.emailGuest).map(key => {
        return {
          key,
          value: this.emailGuest[key] || 'n/a'
        }
      })
    },
    items () {
      return this.entries.map(entry => {
        const email = entry.email.length > this.descriptionLimit
          ? entry.email.slice(0, this.descriptionLimit) + '...'
          : entry.email

        return Object.assign({}, entry, { email })
      })
    }
  },
  watch: {
    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
    search2 (val) {
      if (val !== null && val !== undefined) {
        if (val.length > 2) {
          this.isLoading = true
          // Lazily load input items
          HTTP.get('guests/filter?search=' + val, {
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(response => {
            if (this.entries.length > 0) {
              for (var i = 0; i < response.data.length; i++) {
                this.entries.push(response.data[i])
              }
            } else {
              this.entries = response.data
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => (this.isLoading = false))
        }
      }
    }
  },
  methods: {
    getTutors () {
      this.loadingTutors = true
      HTTP.get('tutor/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.tutors = response.data
        this.loadingTutors = false
      })
      .catch(error => {
        console.log(error)
        this.loadingTutors = false
      })
    },
    createTutor () {
      if (this.band_cellphone === true) {
        this.loading = true
        this.errores = []
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null

        bodyFormData.set('first_name', this.first_name)
        bodyFormData.set('last_name', this.last_name)
        bodyFormData.set('cellNumber', this.celular)
        bodyFormData.set('email', this.email.toLowerCase())
        bodyFormData.set('password', this.password)
        if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
          fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front.jpeg')
        }
        bodyFormData.append('idFront', fileImageFront)
        if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
          fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back.jpeg')
        }
        bodyFormData.append('idBack', fileImageBack)
        if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
          fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar.jpeg')
        }
        bodyFormData.append('avatar', fileImageProfile)
        HTTP.post('tutor/', bodyFormData, {
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        .then(ok => {
          this.loading = false
          console.log(ok)
          this.getTutors()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_tutor_alta'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    updateTutor (id) {
      if (this.band_cellphone === true) {
        this.loading = true
        this.errores = []
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null

        // Evitar Campo Fraccionamiento vacío
        if (this.id_house === undefined) {
          this.id_house = ''
        }
        if (this.email_aux !== this.email) {
          // idUser['email'] = this.email.toLowerCase()
          bodyFormData.set('email', this.email.toLowerCase())
        }
        if (this.celular_aux !== this.celular) {
          bodyFormData.set('cellNumber', this.celular)
          // idUser['cellNumber'] = this.celular
        }
        if (this.change_password === true) {
          bodyFormData.set('password', this.password)
          // idUser['password'] = this.password
        }
        if (this.resultFrontURL !== this.resultAuxFrontURL) {
          const newID = this.$uuid.v4()
          if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
            fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front' + newID + '.jpeg')
          }
          bodyFormData.append('idFront', fileImageFront)
        }
        if (this.resultBackURL !== this.resultAuxBackURL) {
          const newID = this.$uuid.v4()
          if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
            fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back' + newID + '.jpeg')
          }
          bodyFormData.append('idBack', fileImageBack)
        }
        if (this.resultProfileURL !== this.resultAuxProfileURL) {
          const newID = this.$uuid.v4()
          if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
            fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar' + newID + '.jpeg')
          }
          bodyFormData.append('avatar', fileImageProfile)
        }
        bodyFormData.set('first_name', this.first_name)
        bodyFormData.set('last_name', this.last_name)
        HTTP.patch('tutor/' + id, bodyFormData, {
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        .then(ok => {
          this.loading = false
          console.log(ok)
          this.getTutors()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_tutor_modificado'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          // console.log(error.response.data)
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    deleteTutor () {
      HTTP.delete('tutor/' + this.idGuardDelete, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        // console.log('Guard con ID = ', this.idGuardDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_tutor_eliminado'))
        this.getTutors()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
      .catch(error => {
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    moveUpUserToGuard () {
      HTTP.patch('tutor/make_from_guest/', {
        idUser: this.emailGuest
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        this.getTutors()
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('msg_cambio_permisos'))
        this.dialogMoveUp = false
        setTimeout(this.clear, 3000)
      })
      .catch(error => {
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    clear () {
      this.alerta = false
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    fillFields (item) {
      this.first_name = item.first_name
      this.last_name = item.last_name
      this.celular = item.cellNumber
      this.email = item.email
      this.email_aux = item.email
      this.celular_aux = item.cellNumber
      this.password = ''
      this.confirmation = ''
      this.change_password = false
      this.activa = item.is_active
      this.resultFrontURL = item.idFront
      this.resultBackURL = item.idBack
      this.resultProfileURL = item.avatar
      this.resultAuxFrontURL = item.idFront
      this.resultAuxBackURL = item.idBack
      this.resultAuxProfileURL = item.avatar
      this.band_cellphone = true
    },
    customFilter (item, queryText) {
      const textOne = item.street.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    cleanFields () {
      this.id_house = ''
      this.first_name = ''
      this.last_name = ''
      this.celular = ''
      this.email = ''
      this.email_aux = ''
      this.celular_aux = ''
      this.password = ''
      this.confirmation = ''
      this.change_password = true
      this.resultFrontURL = ''
      this.resultBackURL = ''
      this.resultProfileURL = ''
    },
    getCutingFront () {
      // console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageFront.clip() // call component's clip method
      this.resultFrontURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      this.dialogImageFront = false
      this.dialog = true
    },
    getCutingBack () {
      const canvas = this.$refs.clipperImageBack.clip() // call component's clip method
      this.resultBackURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      this.dialogImageBack = false
      this.dialog = true
    },
    getCutingProfile () {
      const canvas = this.$refs.clipperImageProfile.clip() // call component's clip method
      this.resultProfileURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      this.dialogImageProfile = false
      this.dialog = true
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onInput ({ number, isValid }) {
      this.celular = number.e164
      this.band_cellphone = isValid
    },
    example: item => item.first_name + ' ' + item.last_name,
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #00A1E4 #00A1E4 #00A1E4 #00A1E4;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
</style>
